export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7101.3ea00930.jpg";